import Link from "@/components/common/Link";
import { useJarallax } from "@/hooks/useJarallax";
import { useI18n } from "@/common/I18nProvider";
import 'jarallax/dist/jarallax.css';

interface BreadcrumbProps {
  title?: string;
  pageLink?: string;
}

export default function Breadcrumb({ title, pageLink }: BreadcrumbProps) {
  const jarallaxRef = useJarallax(0.6);
  const { messages } = useI18n();
  const homeLabel = messages.nav?.home || "Home";
  const currentLabel = pageLink || title || homeLabel;
  const headingLabel = title || currentLabel;

  return (
    <div
      className="breadcrumb-section bg-img jarallax"
      ref={jarallaxRef}
    >
      <div className="container">
        {/* Breadcrumb Content */}
        <div className="breadcrumb-content">
          <div className="divider"></div>
          <h2>{headingLabel}</h2>
          <ul className="list-unstyled">
            <li>
              <Link href="/">{homeLabel}</Link>
            </li>
            <li>{headingLabel}</li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <div className="divider"></div>
    </div>
  );
}
